/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Complete_ToastInputs */

const en_dialogue_list_export_complete_toast = /** @type {(inputs: Dialogue_List_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Complete`)
};

const fr_dialogue_list_export_complete_toast = /** @type {(inputs: Dialogue_List_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation terminée`)
};

const de_dialogue_list_export_complete_toast = /** @type {(inputs: Dialogue_List_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export abgeschlossen`)
};

const it_dialogue_list_export_complete_toast = /** @type {(inputs: Dialogue_List_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione completata`)
};

const ru_dialogue_list_export_complete_toast = /** @type {(inputs: Dialogue_List_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт завершен`)
};

const es_dialogue_list_export_complete_toast = /** @type {(inputs: Dialogue_List_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación completa`)
};

const zh_cn2_dialogue_list_export_complete_toast = /** @type {(inputs: Dialogue_List_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出完成`)
};

const ja_dialogue_list_export_complete_toast = /** @type {(inputs: Dialogue_List_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポート完了`)
};

const hi_dialogue_list_export_complete_toast = /** @type {(inputs: Dialogue_List_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात पूर्ण`)
};

const pt_pt2_dialogue_list_export_complete_toast = /** @type {(inputs: Dialogue_List_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação concluída`)
};

/**
* | output |
* | --- |
* | "Export Complete" |
*
* @param {Dialogue_List_Export_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_complete_toast = /** @type {((inputs?: Dialogue_List_Export_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_complete_toast(inputs)
	if (locale === "de") return de_dialogue_list_export_complete_toast(inputs)
	if (locale === "it") return it_dialogue_list_export_complete_toast(inputs)
	if (locale === "ru") return ru_dialogue_list_export_complete_toast(inputs)
	if (locale === "es") return es_dialogue_list_export_complete_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_complete_toast(inputs)
	if (locale === "ja") return ja_dialogue_list_export_complete_toast(inputs)
	if (locale === "hi") return hi_dialogue_list_export_complete_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_complete_toast(inputs)
	return en_dialogue_list_export_complete_toast(inputs)
});